import { Component, OnInit, NgZone } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { WindowreffService } from '../services/windowreff.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariable } from '../core/global.variable';

@Component({
  selector: 'app-user-plans',
  templateUrl: './user-plans.component.html',
  styleUrls: ['./user-plans.component.css']
})
export class UserPlansComponent implements OnInit {
  plans: any = []
  finalObj: any = {
    customerDetail: {
      name: '',
      phone: '',
      email: ''
    },
    cardDetail: {
      cardNumber: '',
      cardExpDate: '',
      cardCvv: '',

    },
    addressDetail: {
      address: '',
      landmark: '',
      city: '',
      state: '',
      pincode: ''
    }
  }
  sendBookingData: any = {
    plan_id: '',
    transaction_id: ''
  };

  allPlans = [];

  constructor(
    private authSvc: AuthService,
    private winRef: WindowreffService,
    private toaster: ToastrService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.listPlans();
    this.getProfile();
  }

  listPlans() {
    this.authSvc.listPlans().subscribe(res => {
      this.plans = res["data"];
      this.getProfile();
    })
  }

  getProfile() {
    this.authSvc.getProfile()
      .subscribe(res => {
        this.allPlans = res['data'].plans;

        this.plans.map(data => {
          let index = this.allPlans.findIndex(x => x.plan_id == data['_id']);
          if(index > -1) {
            data['isSubscribed'] = true;
          } else {
            data['isSubscribed'] = false;
          }
        })

      });
  }

  availPlan() {

  }
  payWithRazor(plan) {



    let options: any = {
      "key": GlobalVariable.razor_pay_key,
      "amount": plan.price * 100,
      "name": "Daktarz",
      "description": "Subscription Plan",
      //  "image": "./assets/images/logo.png",
      "modal": {
        "escape": false
      },
      "theme": {
        "color": "#26abe3"
      }
    };
    options.handler = ((response) => {
      console.log(response)
      if (response.razorpay_payment_id) {
        this.sendBookingData["transaction_id"] = response.razorpay_payment_id
        this.sendBookingData["plan_id"] = plan._id
        this.buyPlan(plan)
      }
      // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
    });
    options.modal.ondismiss = (() => {
      //  this.loginService.SetLoader = false;
    });
    let rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();

  }

  buyPlan(plan) {
    this.authSvc.buyPlan(this.sendBookingData).subscribe(res => {
      this.allPlans = res['data'].plans;
      this.ngZone.run(() => {
        this.toaster.success("Successfully subscribed to " + plan.name, '', {
          timeOut: 2000
        });



      })



    }, error => {
      this.toaster.error(error.error.message, '', {
        timeOut: 2000
      });
    })
  }
}
